<template>
<div v-for="(reqProf,index) in this.requestProfiles" v-bind:key="index"  class="w-full">
  <Fieldset 
              :style="`${reqProf.executed ? 'border:3px solid rgb(20, 184, 166)' : 'border:3px solid rgb(255, 0, 0)'}`"
              class="multipack">
    <template #legend>
      <span v-if="reqProf.executed" class="font-medium text-teal-500">{{this.$props.typ == 1 ? 'Rezervované' : 'Prestriekané' }}</span>
      <span v-if="!reqProf.executed" class="font-medium text-red-500">{{this.$props.typ == 1 ? 'Nerezervované' : 'Neprestriekané'}}</span>
    </template>
    <div class="grid ml-0 mr-0">
        <div class="col-4 pl-0 pr-1 pb-0">
            <div style="width: 7rem">
                <img  :src="reqProf.product.image" 
                      :style="`${reqProf.imageHeight >= reqProf.imageWidth ? 'height:60px;' : 'width:115px;'}`"
                     
                      :alt="reqProf.product.image" class="shadow-4 border-round"  />
            </div>
            <!--   @load="checkImageSize(index,$event)" -->
        </div>
      <div class="col-8 pl-0 pr-1 pb-0 flex flex-wrap">
        <div class="flex w-12 md:w-8 lg:w-8 p-1">
            <div class="field w-3 mb-1">
                <label class="mb-1 font-medium" for="req-prof-code">Kód</label>
                <div id="req-prof-code" class="flex align-items-center">
                    <div >
                        {{ reqProf.product.code }}
                    </div>
                </div>
            </div>

            <div class="field w-9 mb-1">
                <label class="mb-1 font-medium" for="req-prof-name">Názov</label>
                <div id="req-prof-name" class="flex align-items-center">
                    <div >
                        {{ reqProf.product.name }}
                    </div>
                </div>
            </div>
        </div>

        <div class="flex w-12 md:w-4 lg:w-4 p-1">
            <div class="field w-6 mb-1">
                <label class="mb-1 font-medium" for="req-prof-color">{{this.$props.typ == 1 ? 'Farba' : 'Nová farba'}}</label>
                <div id="req-prof-color" class="flex align-items-center">
                    <div 
                        class="color-box mr-1"
                        :style="{ backgroundColor: reqProf.color.colorHash }"
                    ></div>
                    <div>{{ reqProf.color.code }}</div>
                </div>
            </div>

            <div class="field w-6 mb-1">
                <label class="mb-1 font-medium" for="req-prof-pc">Počet kusov</label>
                <div id="req-prof-pc" class="flex align-items-center">
                    <div >
                        {{ reqProf.numberOfPieces }}
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>

    <div class="flex justify-content-center ">
        <div class="w-6 pt-1 pl-1 pr-2 pb-1 flex justify-content-center">
          <PrimevueButton @click="confirmReqProfReserve(reqProf)" 
            :label="!reqProf.executed ? (this.$props.typ == 1 ? 'Označiť za rezervované' : 'Označiť za prestriekané') : 'Vrátiť označenie' " 
            :severity="!reqProf.executed ? 'success' : 'warning'" :icon="!reqProf.executed ? 'pi pi-check' : 'pi pi-undo' " text raised class="w-12 md:w-10 uppercase"/>
        </div>
        <div v-if="store.user.admin === true || store.user.department.id == 3" class="w-6 pt-1 pl-2 pr-1 pb-1 flex justify-content-center">
          <PrimevueButton  @click="confirmReqProfDelete(reqProf)" label="Odstrániť" severity="danger" icon="pi pi-trash"
            v-tooltip.top="{ value: `${reqProf.executed ? 
             (this.$props.typ == 1 ? 'Vyžiadanie o rezerváciu nie je možné odstrániť ak bol profil už rezervovaný' : 'Vyžiadanie o prestriekanie nie je možné odstrániť ak bol profil už prestriekaný') : ''}` }"
            text raised class="w-12 md:w-10 uppercase"/>
        </div>
    </div>
    </Fieldset>   
</div>           
</template>

<script lang="ts">
import Security from "@/components/security";
import {store} from "@/components/store";
import notie from "notie/dist/notie";
//import router from "@/router";
import PrimevueButton from 'primevue/button';
import {emiter} from '../main';
import Fieldset from 'primevue/fieldset';


export default {
  name: "RequestProfileReserveList",
  components: {

      PrimevueButton,
      Fieldset,

  },
  props: [
           "resReqId",
           "typ",
         ],
  data() {
    return {
      store,
      requestProfiles: [],
    }
  },

  beforeMount() {
    
    if (Security.requireToken()){
      
      //this.routeParams = this.$route.params
      store.selectModul = this.$route.path.split("/")[1]

      this.loadData()
      emiter.on('reloadReqProfRes',this.loadData)
    }

  },
  
  methods: {

    loadData(){

        let query = "deleted:0,res_req_id:"+String(this.$props.resReqId);
        let url = "/v1/request-profile-reserve?query="
        
        if (this.$props.typ == 2){
          query = "deleted:0,spray_req_id:"+String(this.$props.resReqId);
          url = "/v1/request-profile-spray?query="
        }

        fetch(`${store.Api_url}${url}${query}`, Security.requestOptions("GET"))
        .then((response) => response.json())
        .then((responseData) => {
        if (responseData.error) {
            notie.alert({
            type: "error",
            text: responseData.message,
            position: "bottom",
            });
        } else {
            if (responseData.data) {
              this.requestProfiles = responseData.data;
              this.requestProfiles.forEach((rp,index) => {
                this.checkImage(index)
              })
            } else {
              this.requestProfiles = [];
              this.$emit('delete-res-req',true);
              //console.log("deleteIsPossible");
            }
        }
        });

    },
    
    getImageSize(src) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.src = src

        img.onload = () => {
          resolve({
            width: img.width,
            height: img.height
          })
        }

        img.onerror = reject
      })
    },

    async checkImage(index:number) {
      try {
        const size = await this.getImageSize(this.requestProfiles[index].product.image)
        this.requestProfiles[index].imageWidth = size.width
        this.requestProfiles[index].imageHeight = size.height
      } catch (error) {
        this.requestProfiles[index].imageWidth = 0
        this.requestProfiles[index].imageHeight = 0       
      }
    },


    checkImageSize(index,event) {
      this.requestProfiles[index].imageWidth = event.target.naturalWidth;
      this.requestProfiles[index].imageHeight = event.target.naturalHeight;
    },

    confirmReqProfReserve(reqProf){

        this.$confirm.require({
                        message: 'Naozaj chcete vykonať danú akciu ?' ,
                        header: 'Potvrdenie vykonania akcie',
                        icon: 'pi pi-exclamation-triangle',
                        acceptLabel: "Áno",
                        rejectLabel: "Nie",

                        accept: () => {
                            this.reqProfReserve(reqProf)
                            
                        },

                    })                   

    },

    reqProfReserve(reqProf){
        
        let formData = {
            id: reqProf.id,
            executed: true,
        }

        if (reqProf.executed){
            formData = {
                id: reqProf.id,
                executed: false,
            }
        }

        const method = "PUT"

        let url = "/v1/request-profile-reserve/" + String(reqProf.id)

        if (this.$props.typ == 2){
           url = "/v1/request-profile-spray/" + String(reqProf.id)
        }

        fetch(store.Api_url + url, Security.requestOptions(method, formData))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
            
              notie.alert({
                type: 'error',
                text: responseData.message
              })
            } else {
              notie.alert({
                type: 'success',
                text: "Žiadosť bola vybavená"
              })
                this.loadData()
                //router.push("/mod-stock/reservation-requests/"+String(this.$props.resReqId));
                emiter.emit('reloadReservationRequest')
            }
          })
          .catch((error) => {
            //this.$emit('error', "Chyba pri žiadosti o rezerváciu" + error);
            notie.alert({
              type: 'error',
              text: "Chyba pri vybavení žiadosti " + error
            })
          })

    },

    confirmReqProfDelete(reqProf){
      
      if (!reqProf.executed){

        this.$confirm.require({
            message: 'Naozaj chcete odstrániť vyžiadanie '+ (this.$props.typ == 2 ? 'rezervácie profilu': 'prestriekania profilu') + '?',
            header: 'Odstránenie vyžiadania',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: "Áno",
            rejectLabel: "Nie",

            accept: () => {
              this.deleteReqProf(reqProf.id)
              
            },

        });
      }
    },

    deleteReqProf(id:number){
      
      Security.requireToken();
     
      let url = "/v1/request-profile-reserve/" + String(id)

      if (this.$props.typ == 2){
           url = "/v1/request-profile-spray/" + String(id)
      }

      fetch(store.Api_url + url, Security.requestOptions("DELETE"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {

              notie.alert({
                  type: 'error',
                  text: responseData.message,
                  position: "top"
                })           
            } else {

              notie.alert({
                type: 'success',
                text: "Vyžiadanie bolo úspešne odstránené",
                position: "bottom"
              })

              this.loadData()
            }
          })
          .catch((error) => {
            alert('Chyba pri odstránení vyžiadania: ' + error)
          })
      
    },

  },
  beforeUnmount(){
        emiter.off('reloadReqProfRes',this.loadData)

  },  

}

</script>


<style scoped>

</style>